import { EventEmitter, Component, forwardRef, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultiselectControlModule } from '@mt-ng2/multiselect-control';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/multiselect-control';
class MtSearchFilterItem {
    /* istanbul ignore next */
    constructor(Item, Selected) {
        this.Item = Item;
        this.Selected = Selected;
    }
}
class MtSearchFilterSelectComponent {
    constructor() {
        this.valueIdAccessor = 'Id';
        this.showSelectAllButtons = true;
        this.disabled = false;
        this.selectionChanged = new EventEmitter();
        this.selectListClosed = new EventEmitter();
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
    }
    // *** CONTROL VALUE ACCESSOR ***
    /* tslint:disable:member-ordering */
    writeValue(obj) {
        this.handleWriteValue(obj);
    }
    registerOnChange(fn) {
        this.onValueChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    multiSelectSelectionChanged(event) {
        this.selectedItems = event.selectedItems;
        const eventToEmit = {
            selectedItems: this.selectedItems,
        };
        this.selectionChanged.emit(eventToEmit);
        this.updateValue();
    }
    updateValue() {
        if (!this.onValueChanged) {
            return;
        }
        let value = this.selectedItems;
        if ((value === null || value === void 0 ? void 0 : value.length) && this.valueIdAccessor && value[0][this.valueIdAccessor]) {
            value = value.map((item) => item[this.valueIdAccessor]);
        }
        value = (value === null || value === void 0 ? void 0 : value.length) ? value : null; // set to null if no values in array
        this.onValueChanged(value);
    }
    handleWriteValue(value) {
        this.items.forEach((item) => {
            if (!(value === null || value === void 0 ? void 0 : value.length)) {
                item.Selected = false;
            }
            else if (this.valueIdAccessor) {
                item.Selected = value.some((id) => item.Item[this.valueIdAccessor] === id);
            }
            else {
                item.Selected = value.some((valueItem) => JSON.stringify(item.Item) === JSON.stringify(valueItem));
            }
        });
    }
    handleFocus(event) {
        var _a;
        this.focus.emit(event);
        (_a = this.onTouched) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    handleBlur(event) {
        this.blur.emit(event);
        const eventToEmit = {
            selectedItems: this.selectedItems,
        };
        this.selectListClosed.emit(eventToEmit);
    }
}
MtSearchFilterSelectComponent.ɵfac = function MtSearchFilterSelectComponent_Factory(t) { return new (t || MtSearchFilterSelectComponent)(); };
MtSearchFilterSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MtSearchFilterSelectComponent, selectors: [["mt-search-filter-select"]], inputs: { valueIdAccessor: "valueIdAccessor", showSelectAllButtons: "showSelectAllButtons", disabled: "disabled", items: "items", entity: "entity", maxToShowInSelectedText: "maxToShowInSelectedText", autoClose: "autoClose" }, outputs: { selectionChanged: "onSelectionChanged", selectListClosed: "onSelectListClosed", blur: "blur", focus: "focus" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MtSearchFilterSelectComponent)
            },
        ])], decls: 4, vars: 7, consts: [[3, "items", "filterMode", "entity", "showSelectAllButtons", "maxToShowInSelectedText", "disabled", "autoClose", "onSelectionChanged", "blur", "focus"]], template: function MtSearchFilterSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "multiselect", 0);
        ɵngcc0.ɵɵlistener("onSelectionChanged", function MtSearchFilterSelectComponent_Template_multiselect_onSelectionChanged_1_listener($event) { return ctx.multiSelectSelectionChanged($event); })("blur", function MtSearchFilterSelectComponent_Template_multiselect_blur_1_listener($event) { return ctx.handleBlur($event); })("focus", function MtSearchFilterSelectComponent_Template_multiselect_focus_1_listener($event) { return ctx.handleFocus($event); });
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(3, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("items", ctx.items)("filterMode", true)("entity", ctx.entity)("showSelectAllButtons", ctx.showSelectAllButtons)("maxToShowInSelectedText", ctx.maxToShowInSelectedText)("disabled", ctx.disabled)("autoClose", ctx.autoClose);
    } }, directives: [ɵngcc1.MultiselectComponent], encapsulation: 2 });
MtSearchFilterSelectComponent.ctorParameters = () => [];
MtSearchFilterSelectComponent.propDecorators = {
    items: [{ type: Input }],
    valueIdAccessor: [{ type: Input }],
    entity: [{ type: Input }],
    showSelectAllButtons: [{ type: Input }],
    maxToShowInSelectedText: [{ type: Input }],
    disabled: [{ type: Input }],
    autoClose: [{ type: Input }],
    selectionChanged: [{ type: Output, args: ['onSelectionChanged',] }],
    selectListClosed: [{ type: Output, args: ['onSelectListClosed',] }],
    blur: [{ type: Output }],
    focus: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtSearchFilterSelectComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MtSearchFilterSelectComponent)
                    },
                ],
                selector: 'mt-search-filter-select',
                template: `
        <multiselect
            [items]="items"
            [filterMode]="true"
            [entity]="entity"
            [showSelectAllButtons]="showSelectAllButtons"
            [maxToShowInSelectedText]="maxToShowInSelectedText"
            [disabled]="disabled"
            [autoClose]="autoClose"
            (onSelectionChanged)="multiSelectSelectionChanged($event)"
            (blur)="handleBlur($event)"
            (focus)="handleFocus($event)"
        >
        </multiselect>
    `
            }]
    }], function () { return []; }, { valueIdAccessor: [{
            type: Input
        }], showSelectAllButtons: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selectionChanged: [{
            type: Output,
            args: ['onSelectionChanged']
        }], selectListClosed: [{
            type: Output,
            args: ['onSelectListClosed']
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], items: [{
            type: Input
        }], entity: [{
            type: Input
        }], maxToShowInSelectedText: [{
            type: Input
        }], autoClose: [{
            type: Input
        }] }); })();

class MtSearchFilterSelectModule {
}
MtSearchFilterSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtSearchFilterSelectModule });
MtSearchFilterSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtSearchFilterSelectModule_Factory(t) { return new (t || MtSearchFilterSelectModule)(); }, imports: [[CommonModule, MultiselectControlModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtSearchFilterSelectModule, { declarations: function () { return [MtSearchFilterSelectComponent]; }, imports: function () { return [CommonModule, MultiselectControlModule]; }, exports: function () { return [MtSearchFilterSelectComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtSearchFilterSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [MtSearchFilterSelectComponent],
                exports: [MtSearchFilterSelectComponent],
                imports: [CommonModule, MultiselectControlModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtSearchFilterItem, MtSearchFilterSelectComponent, MtSearchFilterSelectModule };

//# sourceMappingURL=mt-ng2-search-filter-select-control.js.map